import React, { useState, Fragment, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Backdrop,
  CircularProgress,
  TextField,
  Divider,
} from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useSnackbar } from "notistack";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import Alert from "widgets/alert";
import clientBackend, { clientPay } from "configurations/axios";
import {
  API_GET_COMPANY_AUTOCOMPLETE,
  API_POST_ADD_PARTNER,
} from "../apis";
import { validationPartner } from "../validations";

const useStyles = makeStyles((theme) => ({
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  textFieldComboBox: {
    minWidth: "100%",
    maxWidth: "100%",
  },
}));

const AsignarPerfilPartner = ({ updateView }) => {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [openLoader, setOpenLoader] = useState(false);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const [open, setOpen] = useState(false);
  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErros] = useState({});
  const [errorsCompany, setErrorsCompany] = useState({});
  const [registroUsuarioPartner, setRegistroUsuarioPartner] = useState({});
  const [foundClient, setFoundClient] = useState({});
  const [openSearch, setOpenSearch] = useState(false);
  const loading = openSearch && company.length === 0;

  const handleClickOpen = () => {
    setOpen(true);
    setErros({});
    setSelectedCompany({});
  };

  useEffect(() => {
    if (!openSearch) {
      setCompany([]);
    }
  }, [openSearch]);

  const handleClose = () => {
    setOpen(false);
    setMsg({ show: false, msg: null, type: null });
    setCompany([]);
    setRegistroUsuarioPartner({});
  };
  function closeAlert() {
    setMsg({ show: false });
  }

  //método para la busqueda
  const searchClients = async (params) => {
    await clientPay
      .get(API_GET_COMPANY_AUTOCOMPLETE + `?parametroBusqueda=${params}`)
      .then((response) => {
        if (response.status === 200) {
          //setOptions(Object.keys(response.data).map((cliente) => response.data[cliente].cliente));
          if (Array.isArray(response.data)) {
            if (response.data.length > 0) {
              let companies = response.data;
              for (let i = 0; i < companies.length; i++) {
                companies[i].label =
                  companies[i].razonSocialempresa +
                  " / " +
                  companies[i].idempresacontratante;
              }
              let companiesPartner = companies.filter(
                (company) => company.esPartner == "No"
              );
              setCompany(companiesPartner);
            } else {
              setCompany([
                {
                  label: "No se encontró datos con el argumento ingresado",
                },
              ]);
            }
          }
          setOpenSearch(true);
        }
      })
      .catch((exception) => {
        if (exception.response) {
          setCompany([
            {
              label: "No se encontró datos con el argumento ingresado",
            },
          ]);
        } else {
          setCompany([
            {
              label: "Error en la red al consultar el cliente.",
            },
          ]);
        }
      });
  };

  const handleAddPartner = async (event) => {
    setOpenLoader(true);
    let errorCompany = {};
    event.preventDefault();
    if (selectedCompany) {
      if (
        selectedCompany.idempresacontratante === null ||
        typeof selectedCompany.idempresacontratante === "undefined"
      ) {
        errorCompany.selectedCompany = "Seleccione una empresa.";
      }
    } else {
      errorCompany.selectedCompany = "Seleccione una empresa.";
    }
    setErrorsCompany(errorCompany);
    let newErrors = validationPartner.addUser(registroUsuarioPartner);
    setErros(newErrors);
    registroUsuarioPartner.idEmpresa = selectedCompany.idempresacontratante;
    if (
      Object.keys(newErrors).length === 0 &&
      Object.keys(errorCompany).length === 0
    ) {
      await clientBackend
        .post(API_POST_ADD_PARTNER, registroUsuarioPartner)
        .then((response) => {
          if (response.status === 200) {
            enqueueSnackbar("Usuario Registrado como Partner.", {
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              autoHideDuration: 10000,
            });
            updateView();
            setOpenLoader(false);
            setOpen(false);
          }
        })
        .catch((exception) => {
          if (exception.response) {
            if (exception.response.status === 400) {
              setMsg({ show: true, msg: "No se pudo almacenar el usuario." });
            } else if (exception.response.status === 404) {
              setMsg({
                show: true,
                msg: "No se encontró la empresa enviada para relacionarla con el usuario.",
              });
            } else if (exception.response.status === 409) {
              if (
                typeof exception.response.data === "object" &&
                exception.response.data !== null
              ) {
                if (
                  typeof exception.response.data.apierror === "object" &&
                  exception.response.data.apierror !== null
                ) {
                  setMsg({
                    show: true,
                    msg:
                      exception.response.data.apierror.mensajeSistema ||
                      "La Identificación o el Correo ya se encuentra registrado a otro usuario del sistema",
                  });
                } else {
                  setMsg({
                    show: true,
                    msg: "La Identificación o el Correo ya se encuentra registrado a otro usuario del sistema",
                  });
                }
              } else {
                setMsg({
                  show: true,
                  msg: "La Identificación o el Correo ya se encuentra registrado a otro usuario del sistema",
                });
              }
            } else {
              setMsg({
                show: true,
                msg: "Error al registrar el usuario. Contáctese con el administrador del Sistema.",
              });
            }
          } else {
            setMsg({
              show: true,
              msg: "Existen problemas en la red. Contáctese con el administrador del Sistema.",
            });
          }
          setOpenLoader(false);
        });
    }
    setOpenLoader(false);
  };

  const handleChange = (event) => {
    let value = event.target.value;
    if (
      event.target.name === "identificacionUsuario" ||
      event.target.name === "correoPrincipalUsuario"
    ) {
      value = value.trim();
    }
    setRegistroUsuarioPartner({
      ...registroUsuarioPartner,
      [event.target.name]: value,
    });
  };

  return (
    <Fragment>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        <PersonIcon
          style={{ color: palette.primary.contrastText, paddingRight: "3%" }}
          fontSize="small"
        />
        {"  "}
        Asignar Perfil Partner
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">
          Asignar perfil partner a la empresa {" "}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleAddPartner}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item xs={12} md={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>
              {msgError.show ? (
                <Alert
                  tipo={msgError.type}
                  mensaje={msgError.msg}
                  mesajeSubrayado={null}
                  titulo={null}
                  mostrar={msgError.show}
                  cerrarAlerta={closeAlert}
                />
              ) : null}
              <Grid item xs={12} md={2}>
                Empresa: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={10}>
                <Autocomplete
                  id="rucCliente"
                  onChange={(e, value) => {
                    setFoundClient(value);
                    if (value !== null) {
                      setSelectedCompany(value);
                    } else {
                      setSelectedCompany({});
                    }
                  }}
                  open={openSearch}
                  onOpen={() => {
                    setOpenSearch(true);
                  }}
                  onClose={() => {
                    setOpenSearch(false);
                  }}
                  getOptionDisabled={(option) =>
                    option.label.includes(
                      "No se encontró datos con el argumento ingresado"
                    ) ||
                    option.label.includes(
                      "Error en la red al consultar el cliente."
                    )
                  }
                  getOptionSelected={(option, value) =>
                    option.idempresacontratante === value.idempresacontratante
                  }
                  getOptionLabel={(option) => option.label}
                  options={company}
                  noOptionsText={
                    "No se encontró datos con el argumento ingresado"
                  }
                  //inputValue={foundClient}
                  loadingText="Ingrese al menos 3 caracteres"
                  loading={company.length === 0}
                  renderInput={(params) => (
                    <TextField
                      className={
                        foundClient
                          ? foundClient.label
                            ? "form-control  is-valid"
                            : null
                          : null
                      }
                      onChange={(event) => {
                        if (event.target.value.length >= 2) {
                          searchClients(event.target.value);
                        }
                      }}
                      {...params}
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
                <small style={{ color: "#818181" }}>
                  Puede buscarlo por el RUC o Razón Social.
                </small>
                {errorsCompany.selectedCompany ? (
                  <p className={classesApp.errorLetters}>
                    {errorsCompany.selectedCompany}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Correo para el usuario:{" "}
                <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input
                  type="text"
                  className={
                    errors.correoPrincipalUsuario
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Ej. user@ejemplo.com"
                  name="correoPrincipalUsuario"
                  value={registroUsuarioPartner.correoPrincipalUsuario}
                  onChange={handleChange}
                  autoComplete="off"
                />
                {errors.correoPrincipalUsuario ? (
                  <p className={classesApp.errorLetters}>
                    {errors.correoPrincipalUsuario}
                  </p>
                ) : null}
              </Grid>

              <Grid item xs={12} md={4}>
                Identificación del Usuario (CI/RUC):{" "}
                <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input
                  type="text"
                  className={
                    errors.identificacionUsuario
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Ej. 1737199872"
                  name="identificacionUsuario"
                  value={registroUsuarioPartner.identificacionUsuario}
                  onChange={handleChange}
                  autoComplete="off"
                />
                {errors.identificacionUsuario ? (
                  <p className={classesApp.errorLetters}>
                    {errors.identificacionUsuario}
                  </p>
                ) : null}
              </Grid>
              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider></Divider>
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default AsignarPerfilPartner;
